import type { ReactNode } from 'react';
import React, { createContext, useMemo, useState } from 'react';

import type { FocusedViewContext } from '../types';

const context = createContext<FocusedViewContext>({
  isFocusedView: false,
  setIsFocusedView: () => {},
  toggleFocusedView: () => {},
});

const Provider = ({ children }: { children: ReactNode }) => {
  const [isFocusedView, setIsFocusedView] = useState(false);
  const contextValue = useMemo<FocusedViewContext>(
    () => ({
      isFocusedView,
      setIsFocusedView,
      toggleFocusedView: () => setIsFocusedView(!isFocusedView),
    }),
    [isFocusedView, setIsFocusedView],
  );
  return <context.Provider value={contextValue}>{children}</context.Provider>;
};

export { context, Provider };
